import React, { useState, createContext, useContext } from "react";
import api from "../../Utils/api";
import { roles, userPermissions } from "../../Utils/constants";
import { useSelector } from "react-redux";

const apiPath = {
  timesheets: "/timesheet/gettimesheetcount",
  jobs: "/jobnproject/getjobscount",
  users: "/user/getuserscount",
  invoices: "/invoice/get-invoices-count-for-user",
};

const nullFn = () => null;
const CountContext = createContext({
  loading: false,
  counts: {
    timesheets: 0,
    jobs: 0,
    clients: 0,
    consultants: 0,
    vendors: 0,
    invoices: 0,
  },
  fetchCounts: nullFn,
});

export const useCountProvider = () => useContext(CountContext);
const CountProvider = ({ children }) => {
  const permissions = useSelector((state) => state.user.permissions);
  const [loading, setLoading] = useState(false);
  const [timesheets, setTimesheets] = useState(0);
  const [jobs, setJobs] = useState(0);
  const [clients, setClients] = useState(0);
  const [consultants, setConsultants] = useState(0);
  const [vendors, setVendors] = useState(0);
  const [invoices, setInvoices] = useState(0);

  const fetchCounts = async () => {
    setLoading(true);
    try {
      const params = {
        userId: localStorage.getItem("userId"),
        userType: "VENDOR",
      };

      if(permissions.includes(userPermissions.job.timesheetAction)){
        const timesheetRes = await api.get(apiPath.timesheets, { params });
        if (timesheetRes.data?.success) {
          setTimesheets(
            timesheetRes.data.result.approved + timesheetRes.data.result.pending
          );
        }
      }

      if(permissions.includes(userPermissions.job.view)){
        const jobRes = await api.get(apiPath.jobs, { params });
        if (jobRes.data?.success) setJobs(jobRes.data.result);
      }

      const userRes = await api.get(apiPath.users, { params });

      const { userType, ...restParams } = params;
      const invoiceRes = await api.get(apiPath.invoices, {
        params: { ...restParams, mode: roles.client },
      });
      if (userRes.data?.success) {
        setClients(userRes.data.result.clients);
        setVendors(userRes.data.result.vendors);
        setConsultants(userRes.data.result.consultants);
      }
      if (invoiceRes.data?.success) setInvoices(invoiceRes.data.result);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const value = {
    loading,
    counts: { timesheets, jobs, clients, consultants, vendors, invoices },
    fetchCounts,
  };

  return (
    <CountContext.Provider value={value}>{children}</CountContext.Provider>
  );
};

export default CountProvider;
